import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { PAComponiFatturaSempliceComponent } from './pa-componi-fattura-semplice';
import { StorageService } from '../../../../../services/storage.service';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.pa-componi-fattura-semplice', {
            url: '/pa-componi-fattura-semplice',
            params: {
                xmlpath: '',
                requestNotaCredito : false
            },
            ncyBreadcrumb: {
                label: 'Componi Fattura Semplice',
                parent: 'home.fatturazione-pa'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Componi fattura semplice e genera XML'
            },
            'views': {
                'homeContent': {
                    template: '<pa-componi-fattura-semplice flex="100"></pa-componi-fattura-semplice>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const PAComponiFatturaSempliceModule: string = ng
    .module('pa-componi-fattura-semplice', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('paComponiFatturaSemplice', PAComponiFatturaSempliceComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/pa-componi-fattura-semplice/pa-componi-fattura-semplice.module.ts